import Meta from "@/vuex/models/meta";
import LocationFull from "@/vuex/models/location/location-full";

export default class LocationsState {
    public locations: Array<LocationFull> | [] = [];
    public meta!: Meta;
    public location: LocationFull | null = null;
}
